import gql from 'graphql-tag';

export const GET_SOCIAL_AUTH_URL = gql`
    query {
        getSocialAuthUrl(
            providerName: line,
            operationType: link
        ) {
            url
        }
    },
`;
export const LINK_SOCIAL_ACCOUNT_TO_MEMBER = gql`
    mutation{
        linkSocialAccountToMember (providerName: line)
    },
`;

